import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, Type, signal } from '@angular/core';
import { DynamicComponentEntity } from '@dotcms/angular';
import { DotCMSBasicContentlet } from '@dotcms/types';

import { DYNAMIC_COMPONENTS } from '../../configurations/dynamic-components';

@Component({
  selector: 'custom-dot-cms-content-render',
  templateUrl: './dot-cms-uve-content-render.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
})
export class DotCmsUveContentRenderComponent implements OnChanges {
  @Input({ required: true }) contentlet!: DotCMSBasicContentlet;

  // signal holding the resolved component
  $UserComponent = signal<null | Type<DynamicComponentEntity>>(null);

  async ngOnChanges() {
    if (!this.contentlet) {
      return;
    }

    const componentFactory = DYNAMIC_COMPONENTS[this.contentlet.contentType] ?? DYNAMIC_COMPONENTS.CustomNoComponent;

    if (!componentFactory) {
      console.warn(`Component not available for contentType: ${this.contentlet.contentType}`);
      this.$UserComponent.set(undefined);
      return;
    }

    try {
      const componentClass = await componentFactory;
      this.$UserComponent.set(componentClass);
    } catch (err) {
      console.error('Failed to load component for', this.contentlet.contentType, err);
      this.$UserComponent.set(undefined);
    }
  }
}
